import { cxTheme } from 'components/storybook-migration/theme-provider/system-design/theme';
import { SPACING_4 } from 'constants/theme-constants';
import styled from 'styled-components';

export const ButtonWrapper = styled.div`
  ${({ theme }) => `
    display: flex;
    justify-content: space-between;
    width: ${cxTheme.spacing[11]};
    height: ${cxTheme.spacing[7]};
    gap: ${cxTheme.spacing[SPACING_4]};

    .shell-button {
      border-color: ${theme.border.medium};

      &:hover {
        border-color: ${theme.border.strong};
      }
    }
  `}
`;

export const DateSelectorWrapper = styled.div`
  ${({ theme }) => `
    display: flex;
    align-items: center;
    gap: ${cxTheme.spacing[SPACING_4]};
  
    
    .shell-date-picker-dropdown.shell-date-picker-dropdown-placement-bottomLeft  {
      z-index: ${cxTheme.zIndex[5]};
    }

    @media screen and (max-width: ${cxTheme.breakpoints.desktop}px) {
      width: 100%;
    }
  `}
`;
